// Copyright (c) 2020-2024 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";

export type FormFooterProps = {
  className?: string;
  classes?: Record<string, string>;
  children?: React.ReactNode;
}

const FormFooter: React.FC<FormFooterProps> = (props: FormFooterProps) => {
  const { children } = props;
  const classes = withStyles.getClasses(props);

  return (
    <footer className={classes.root}>
      {children}
    </footer>
  );
};

const FormFooterStyled = withStyles(
  FormFooter, 
  (theme, props) => ({
    "root": {
      borderTop: `1px solid ${theme.palette.colors.greyLight}`,
      padding: theme.spacing(4, 0, 4, 6),
      height: 110,
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap'
    }
  })
);

export default FormFooterStyled;